module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('p', {
    staticClass: "x2TOC-TTL",
    attrs: {
      "id": "toc_marker-1"
    }
  }, [_vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "x2TOC-first"
  }, [_c('em', {
    staticClass: "italic"
  }, [_c('a', {
    attrs: {
      "id": "From_the_Editor_toc"
    }
  })]), _c('a', {
    attrs: {
      "href": "#/text/9780062292742_From_Editor"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("From the Editor")])]), _c('em', {
    staticClass: "italic"
  })]), _vm._v(" "), _c('p', {
    staticClass: "x2TOC"
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780062292742_Prologue#PROLOGUE"
    }
  }, [_vm._v("Prologue: The Journey")])]), _vm._v(" "), _c('p', {
    staticClass: "x2TOC"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('a', {
    attrs: {
      "id": "x1_toc"
    }
  })]), _c('a', {
    attrs: {
      "href": "#/text/9780062292742_Chapter_1#x1_tx"
    }
  }, [_vm._v("1. Pope of the Slums")])]), _vm._v(" "), _c('p', {
    staticClass: "x2TOC"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('a', {
    attrs: {
      "id": "x2_toc"
    }
  })]), _c('span', {
    attrs: {
      "href": "#/text/9780062292742_Chapter_2#x2_tx",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2. A Church in Turmoil")])]), _vm._v(" "), _c('p', {
    staticClass: "x2TOC"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('a', {
    attrs: {
      "id": "x3_toc"
    }
  })]), _c('span', {
    attrs: {
      "href": "#/text/9780062292742_Chapter_3#x3_tx",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3. A Boy, a Grandmother and a Calling")])]), _vm._v(" "), _c('p', {
    staticClass: "x2TOC"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('a', {
    attrs: {
      "id": "x4_toc"
    }
  })]), _c('span', {
    attrs: {
      "href": "#/text/9780062292742_Chapter_4#x4_tx",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4. The Jesuit and the Generals")])]), _vm._v(" "), _c('p', {
    staticClass: "x2TOC"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('a', {
    attrs: {
      "id": "x5_toc"
    }
  })]), _c('span', {
    attrs: {
      "href": "#/text/9780062292742_Chapter_5#x5_tx",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5. Opening the Church Doors")])]), _vm._v(" "), _c('p', {
    staticClass: "x2TOC"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('a', {
    attrs: {
      "id": "x6_toc"
    }
  })]), _c('span', {
    attrs: {
      "href": "#/text/9780062292742_Chapter_6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6. The Cardinal and the Kirchners")])]), _vm._v(" "), _c('p', {
    staticClass: "x2TOC"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('a', {
    attrs: {
      "id": "x7_toc"
    }
  })]), _c('span', {
    attrs: {
      "href": "#/text/9780062292742_Chapter_7#x7_tx",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7. Two Boys Named Gabriel")])]), _vm._v(" "), _c('p', {
    staticClass: "x2TOC"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('a', {
    attrs: {
      "id": "x8_toc"
    }
  })]), _c('span', {
    attrs: {
      "href": "#/text/9780062292742_Chapter_8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8. The Path to Power")])]), _vm._v(" "), _c('p', {
    staticClass: "x2TOC-last"
  }, [_c('a', {
    attrs: {
      "id": "Epilogue_toc"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/9780062292742_Epilogue#Epilogue_tx",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Epilogue")])]), _vm._v(" "), _c('p', {
    staticClass: "x2TOC"
  }, [_c('em', {
    staticClass: "italic"
  }, [_c('a', {
    attrs: {
      "id": "Photographs_toc"
    }
  })]), _c('span', {
    attrs: {
      "href": "#/text/9780062292742_Photographs#Photographs_tx",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Photographs")])]), _c('em', {
    staticClass: "italic"
  })]), _vm._v(" "), _c('p', {
    staticClass: "x2TOC"
  }, [_c('em', {
    staticClass: "italic"
  }, [_c('a', {
    attrs: {
      "id": "Acknowledgments_toc"
    }
  })]), _c('span', {
    attrs: {
      "href": "#/text/9780062292742_Acknowledgments#Acknowledgments_tx",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Acknowledgments")])]), _c('em', {
    staticClass: "italic"
  })]), _vm._v(" "), _c('p', {
    staticClass: "x2TOC"
  }, [_c('em', {
    staticClass: "italic"
  }, [_c('a', {
    attrs: {
      "id": "About_the_Contributors_toc"
    }
  })]), _c('span', {
    attrs: {
      "href": "#/text/9780062292742_About_Contributors#About_the_Contributors_TX",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("About the Contributors")])]), _c('em', {
    staticClass: "italic"
  })]), _vm._v(" "), _c('p', {
    staticClass: "x2TOC"
  }, [_c('em', {
    staticClass: "italic"
  }, [_c('a', {
    attrs: {
      "id": "Credits_toc"
    }
  })]), _c('span', {
    attrs: {
      "href": "#/text/9780062292742_Credits",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Credits")])]), _c('em', {
    staticClass: "italic"
  })]), _vm._v(" "), _c('p', {
    staticClass: "x2TOC"
  }, [_c('em', {
    staticClass: "italic"
  }, [_c('a', {
    attrs: {
      "id": "Copyright_toc"
    }
  })]), _c('span', {
    attrs: {
      "href": "#/text/9780062292742_Copyright#Copyright_tx",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Copyright")])]), _c('em', {
    staticClass: "italic"
  })]), _vm._v(" "), _c('p', {
    staticClass: "x2TOC"
  }, [_c('em', {
    staticClass: "italic"
  }, [_c('a', {
    attrs: {
      "id": "About_the_Publisher_toc"
    }
  })]), _c('span', {
    attrs: {
      "href": "#/text/About_the_Publisher",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("About the Publisher")])]), _c('em', {
    staticClass: "italic"
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8c2676d4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/9780062292742_Contents.vue
// module id = 63
// module chunks = 0